import React, { useState, useEffect } from "react";
import BackBtn from "../../common/backBTN";
import { Link } from "react-router-dom";

function PersonalInformation() {
  const [userData, setUserData] = useState({
    username: "",
    name: "",
    dofb: "",
    email: "",
    phone: "",
    other_phone_1: "",
    other_phone_2: "",
    vip_coin: 0,
    session_id: "",
    created_at: "",
    email_verified_at: null,
    phone_verified_at: null,
  });

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false); 
  const [verificationCode, setVerificationCode] = useState('');
  const [phoneNumber, setphoneNumber] = useState('');
  const [getotherContracts, setotherContracts] = useState([]);
	const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [timer, setTimer] = useState(0);
  const [errors, setErrors] = useState({});
  // OTP verification state (matches MD doc flow)
  const [verifyType, setVerifyType] = useState(null); // 'phone' | 'email' | null
  const [otpCode, setOtpCode] = useState('');
  const [otpSending, setOtpSending] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const [otpError, setOtpError] = useState('');

const validate = () => {
  const newErrors = {};

  // Name validation (only check if user entered something)
  if (userData.name && userData.name.length < 6) {
    newErrors.name = "Name must be at least 6 letters.";
  }

  // DOB validation (required)
  if (userData.dofb) {
    const birthDate = new Date(userData.dofb);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
    if (age < 18) newErrors.dofb = "You must be at least 18 years old.";
  } else {
    newErrors.dofb = "Date of birth is required.";
  }

  // Email validation (only check if user entered something)
  if (userData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email)) {
    newErrors.email = "Please enter a valid email address.";
  }

  // Phone validation (required)
  if (!/^\d{11}$/.test(userData.phone)) {
    newErrors.phone = "Phone number must be exactly 11 digits.";
  } else if (!userData.phone.startsWith("0")) {
    newErrors.phone = "Phone number must start with 0.";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

  const showMsg = (msg) => {
    setModalMessage(msg);
    setShowModal(true);
  };

  const hostname = typeof window !== 'undefined' && window.location && typeof window.location.hostname === 'string'
    ? window.location.hostname.toLowerCase()
    : '';
  const origin = typeof window !== 'undefined' && window.location && typeof window.location.origin === 'string'
    ? window.location.origin.toLowerCase()
    : '';
  const brand = (process.env.REACT_APP_BRAND || localStorage.getItem('brand') || '').toLowerCase();
  const isRocket88 = hostname.includes('rocket88') || origin.includes('rocket88') || brand.includes('rocket88');

  const fetchOther = async () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setotherContracts(data.data || []);
                    console.log(data.data);
                   
                } else {
                    console.error('Failed to fetch user data');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        }
    };

  const fetchUserData = async () => {
    const token = localStorage.getItem("token");
    const remoteId = localStorage.getItem("remote_id");
    if (!token || !remoteId) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/user/show?remote_id=${remoteId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) throw new Error("Failed to load user profile");
      const data = await res.json();

      // Accept multiple possible backend field names for DOB
      const incomingDob = data.dofb || data.dob || data.date_of_birth || "";
      const createdAtRaw = data.created_at || data.createdAt || null;
      const createdDate = createdAtRaw ? new Date(createdAtRaw) : null;
      const formattedDate = createdDate && !isNaN(createdDate) ? createdDate.toLocaleDateString() : "";
      console.log('[PersonalInformation] Raw user data fetch:', data);
      setUserData({
        username: data.username || 'Unknown User',
        vip_coin: data.vip_coin || 0,
        name: data.name || 'N/A',
        phone: data.phone || '',
        email: data.email || '',
        session_id: data.session_id || '',
        created_at: formattedDate,
        dofb: incomingDob,
        email_verified_at: data.email_verified_at || null,
        phone_verified_at: data.phone_verified_at || null,
      });
    } catch (err) {
      console.error(err);
      showMsg("Error loading user data.");
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  // Timer countdown effect for OTP
  useEffect(() => {
    if (otpTimer <= 0) return;
    const interval = setInterval(() => {
      setOtpTimer((t) => (t <= 1 ? 0 : t - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [otpTimer]);

  // Format timer as MM:SS
  const formatTimer = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };

  // Open OTP popup
  const openOtpPopup = (type) => {
    setVerifyType(type);
    setOtpCode('');
    setOtpSent(false);
    setOtpError('');
    setOtpTimer(0);
  };

  // Close OTP popup
  const closeOtpPopup = () => {
    setVerifyType(null);
    setOtpCode('');
    setOtpSent(false);
    setOtpError('');
    setOtpTimer(0);
  };

  // Send OTP code: first save data to database, then send verification code
  const sendOtpCode = async () => {
    setOtpError('');
    setOtpSending(true);
    try {
      const token = localStorage.getItem('token');
      const remoteId = localStorage.getItem('remote_id');

      // Step 1: Save the data to the database first
      const profilePayload = {
        remote_id: remoteId,
        ...userData,
        dob: userData.dofb,
      };
      const saveRes = await fetch(`${process.env.REACT_APP_API_URL}/api/user/profile/update`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(profilePayload),
      });
      const saveData = await saveRes.json().catch(() => ({}));
      if (!saveRes.ok) {
        setOtpError(saveData?.message || 'Failed to save profile. Please try again.');
        setOtpSending(false);
        return;
      }

      // Step 2: Send the verification code
      const body = verifyType === 'phone'
        ? { phone: userData.phone }
        : { email: userData.email };
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/send-verification-code`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(body),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        setOtpSent(true);
        setOtpTimer(5 * 60); // 5 minutes
      } else {
        setOtpError(data?.message || 'Failed to send code. Please try again.');
      }
    } catch (_) {
      setOtpError('Network error. Please try again.');
    } finally {
      setOtpSending(false);
    }
  };

  // Verify OTP code (per MD doc: /api/verify-phone-number or /api/verify-email)
  const submitOtpCode = async () => {
    if (!otpCode || otpCode.length < 4) {
      setOtpError('Please enter the full verification code.');
      return;
    }
    setOtpError('');
    setOtpVerifying(true);
    try {
      const token = localStorage.getItem('token');
      const endpoint = verifyType === 'phone'
        ? `${process.env.REACT_APP_API_URL}/api/verify-phone-number`
        : `${process.env.REACT_APP_API_URL}/api/verify-email`;
      const body = verifyType === 'phone'
        ? { verification_code: otpCode }
        : { code: otpCode };
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(body),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        showMsg(verifyType === 'phone' ? 'Phone verified successfully!' : 'Email verified successfully!');
        closeOtpPopup();
        fetchUserData();
        fetchOther();
      } else {
        setOtpError(data?.message || 'Invalid or expired code.');
      }
    } catch (_) {
      setOtpError('Something went wrong. Please try again.');
    } finally {
      setOtpVerifying(false);
    }
  };

  const addPhoneNumber = async () => {
        if (isButtonDisabled) return;
    
        setIsButtonDisabled(true);
    
        const token = localStorage.getItem('token');
        if (!token) {
            console.error('User token not found.');
            setIsButtonDisabled(false);
            return;
        }
    
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/add/number`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ phone: phoneNumber }),
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                console.error('Failed to add phone number:', errorData.message || 'Unknown error');
                setIsButtonDisabled(false);
                return;
            }
    
            const verifyResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/add/send-verification-code`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ phone: phoneNumber }),
            });
    
            if (!verifyResponse.ok) {
                const errorData = await verifyResponse.json();
                console.error('Failed to send verification code:', errorData.message || 'Unknown error');
                setIsButtonDisabled(false);
                return;
            }
    
            setIsCodeSent(true);
            setTimer(5 * 60);
    
            let countdown = setInterval(() => {
                setTimer((prevTime) => {
                    if (prevTime <= 0) {
                        clearInterval(countdown);
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);
    
        } catch (error) {
            console.error('Error sending code:', error);
            setIsButtonDisabled(false);
        }
    };

  // === Update Profile ===
  const updateProfile = async (e) => {
     e.preventDefault();
    const isValid = validate();
  if (!isValid) {
    setShowModal(true);
    return; 
  }
    const token = localStorage.getItem("token");
    const remoteId = localStorage.getItem("remote_id");
    if (!token || !remoteId) return;

    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/user/profile/update`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          remote_id: remoteId,
          ...userData,
          // Duplicate DOB field for backend variants expecting 'dob'
          dob: userData.dofb,
        }),
      });

      const data = await res.json();
      if (res.ok) {
        showMsg("Profile updated successfully!");
      } else {
        showMsg(data.message || "Failed to update profile.");
      }
    } catch (err) {
      console.error(err);
      showMsg("Error updating profile.");
    } finally {
      setLoading(false);
    }
  };

  const fieldIcon = (emoji) => (
    <span style={{fontSize: 18, width: 36, textAlign: 'center', flexShrink: 0, opacity: 0.7}}>{emoji}</span>
  );

  const inputStyle = {
    flex: 1,
    background: 'transparent',
    border: 'none',
    outline: 'none',
    color: '#fff',
    fontSize: 14,
    padding: '0 8px',
    height: '100%',
    width: '100%',
  };

  const fieldRowStyle = {
    display: 'flex',
    alignItems: 'center',
    background: '#162c28',
    borderRadius: 12,
    padding: '0 14px',
    height: 52,
    border: '1px solid rgba(255,255,255,0.06)',
  };

  const labelStyle = {
    fontSize: 11,
    color: 'rgba(255,255,255,0.4)',
    marginBottom: 6,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  };

  const verifyBadge = (verified, onVerify) => (
    <div style={{display:'flex', alignItems:'center', gap: 8, marginTop: 6}}>
      {verified ? (
        <span style={{fontSize: 12, color: '#4ade80', display:'flex', alignItems:'center', gap: 3}}>
          <span style={{fontSize: 14}}>✓</span> Verified
        </span>
      ) : (
        <>
          <span style={{fontSize: 12, color: '#f87171', display:'flex', alignItems:'center', gap: 3}}>
            <span style={{fontSize: 14}}>✗</span> Not verified
          </span>
          {onVerify && (
            <button type="button" onClick={onVerify} style={{
              fontSize: 11, padding: '3px 12px', borderRadius: 20,
              border: '1px solid #f87171', background: 'rgba(248,113,113,0.15)',
              color: '#f87171', cursor: 'pointer', fontWeight: 600,
            }}>
              Verify
            </button>
          )}
        </>
      )}
    </div>
  );

  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
      <div className="personalCenter" style={{background:'#091a21', minHeight:'100vh'}}>
        {/* Header */}
        <div className="mc-header-wrap">
          <div id="mc-header" className="mc-navbar-blue mc-index mc-default-header am-navbar am-navbar-light">
            <BackBtn />
            <div className="am-navbar-title">My Account</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>

        {/* User Card */}
        <div style={{
          margin: '16px 16px 0',
          background: 'linear-gradient(135deg, #1a3a33 0%, #162c28 100%)',
          borderRadius: 16,
          padding: '20px 18px',
          border: '1px solid rgba(74,222,128,0.1)',
        }}>
          <div style={{display:'flex', alignItems:'center', gap: 12, marginBottom: 4}}>
            <div style={{
              width: 44, height: 44, borderRadius: 12,
              background: 'linear-gradient(135deg, #4ade80, #22c55e)',
              display:'flex', alignItems:'center', justifyContent:'center',
              fontSize: 20, color: '#091a21', fontWeight: 700,
            }}>
              {(userData.username || 'U')[0].toUpperCase()}
            </div>
            <div>
              <div style={{color:'#fff', fontSize: 16, fontWeight: 600}}>
                {userData.username || 'N/A'}
              </div>
              <div style={{color:'rgba(255,255,255,0.45)', fontSize: 12, marginTop: 2}}>
                {userData.created_at ? `Member since ${userData.created_at}` : 'Member'}
              </div>
            </div>
          </div>
        </div>

        {/* Form Fields */}
        <div style={{padding: '20px 16px 100px'}}>

          {/* Full Name */}
          <div style={{marginBottom: 18}}>
            <div style={labelStyle}>Full Name</div>
            <div style={fieldRowStyle}>
              {fieldIcon('👤')}
              <input
                type="text"
                placeholder="Enter your full name"
                value={userData.name}
                onChange={(e) => setUserData({ ...userData, name: e.target.value })}
                style={inputStyle}
              />
            </div>
          </div>

          {/* Birthday */}
          <div style={{marginBottom: 18}}>
            <div style={labelStyle}>Date of Birth</div>
            <div style={fieldRowStyle}>
              {fieldIcon('🎂')}
              <input
                type="date"
                value={userData.dofb || ''}
                onChange={(e) => setUserData({ ...userData, dofb: e.target.value })}
                style={{...inputStyle, colorScheme: 'dark'}}
              />
            </div>
          </div>

          {/* Email */}
          <div style={{marginBottom: 18}}>
            <div style={labelStyle}>Email Address</div>
            <div style={fieldRowStyle}>
              {fieldIcon('✉️')}
              <input
                type="email"
                placeholder="Enter your email"
                value={userData.email}
                onChange={(e) => setUserData({ ...userData, email: e.target.value })}
                style={inputStyle}
              />
            </div>
            {verifyBadge(
              userData.email_verified_at,
              userData.email ? () => openOtpPopup('email') : null
            )}
          </div>

          {/* Phone */}
          <div style={{marginBottom: 24}}>
            <div style={labelStyle}>Phone Number</div>
            <div style={{display:'flex', gap: 8}}>
              <div style={{
                ...fieldRowStyle, flex:'0 0 auto', width: 100, gap: 6,
                justifyContent: 'center',
              }}>
                <img
                  src="https://images.384894992.com//TCG_PROD_IMAGES/COUNTRY_FLAG/CIRCLE/BD.svg"
                  alt="BD"
                  style={{width: 22, height: 22, borderRadius: '50%'}}
                />
                <span style={{color:'#fff', fontSize: 14, fontWeight: 500}}>+88</span>
              </div>
              <div style={{...fieldRowStyle, flex: 1}}>
                {fieldIcon('📱')}
                <input
                  type="tel"
                  placeholder="Phone number"
                  value={userData.phone}
                  onChange={(e) => setUserData({ ...userData, phone: e.target.value })}
                  style={inputStyle}
                />
              </div>
            </div>
            {verifyBadge(
              String(userData.session_id) === '1',
              userData.phone ? () => openOtpPopup('phone') : null
            )}
          </div>

          {/* Submit Button */}
          <button
            type="button"
            onClick={updateProfile}
            disabled={loading}
            style={{
              width: '100%',
              height: 50,
              borderRadius: 12,
              border: 'none',
              background: loading ? '#1a3a33' : 'linear-gradient(135deg, #4ade80, #22c55e)',
              color: loading ? 'rgba(255,255,255,0.5)' : '#091a21',
              fontSize: 16,
              fontWeight: 700,
              cursor: loading ? 'not-allowed' : 'pointer',
              letterSpacing: 0.5,
              transition: 'all 0.2s',
            }}
          >
            {loading ? 'Updating...' : 'Save Changes'}
          </button>
        </div>

       
        {showModal && (
           <>
           <div className="am-modal-mask" style={{background:'rgba(0,0,0,0.6)'}} />
            <div tabIndex={-1} className="am-modal-wrap" role="dialog" aria-labelledby="rcDialogTitle0">
              <div role="document" className="am-modal am-modal-transparent" style={{width: '5.4rem', height: 'auto'}}>
                <div className="am-modal-content" style={{background:'#162c28', borderRadius: 16, border:'1px solid rgba(74,222,128,0.1)'}}>
                  <div className="am-modal-header" style={{borderBottom:'1px solid rgba(255,255,255,0.06)'}}>
                    <div className="am-modal-title" id="rcDialogTitle0" style={{color:'#fff'}}>Confirmation</div>
                  </div>
                  <div className="am-modal-body" style={{color:'rgba(255,255,255,0.8)'}}>
                     {Object.keys(errors).length > 0 ? (
                    <ul className="change-modal-title" style={{color:'#f87171', textAlign:'left', padding:'0 12px'}}>
                      {Object.entries(errors).map(([field, message]) => (
                        <li key={field} style={{marginBottom: 4}}>{message}</li>
                      ))}
                    </ul>
                  ) : (
                    <div style={{zoom: 1, overflow: 'hidden'}}><div className="change-modal-title" style={{color:'#4ade80'}}>✅ Profile updated successfully!</div></div>
                  )}
                  </div>
                  <div className="am-modal-footer" style={{borderTop:'1px solid rgba(255,255,255,0.06)'}}>
                    <div className="am-modal-button-group-h am-modal-button-group-normal" role="group">
                      <Link className="am-modal-button" onClick={() => setShowModal(false)} role="button" style={{color:'rgba(255,255,255,0.5)'}}>Cancel</Link>
                      <Link className="am-modal-button" onClick={() => setShowModal(false)} role="button" style={{color:'#4ade80', fontWeight:600}}>OK</Link>
                    </div>
                  </div>
                </div>
                <div tabIndex={0} style={{width: '0px', height: '0px', overflow: 'hidden'}}>sentinel</div>
              </div>
            </div>
           </>
        )}

        {/* OTP Verification Popup (matches MD doc .pop-get-vcode pattern) */}
        {verifyType && (
          <>
            <div
              className="pop-bg"
              onClick={closeOtpPopup}
              style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(0,0,0,0.5)',
                zIndex: 9998,
              }}
            />
            <div
              className="pop-get-vcode active"
              style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                background: '#0d2420',
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
                padding: '20px 16px 28px',
                zIndex: 9999,
                maxHeight: '70vh',
                overflow: 'auto',
                border: '1px solid rgba(74,222,128,0.1)',
                borderBottom: 'none',
              }}
            >
              <div className="menu-box">
                {/* Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                  <h3 style={{ margin: 0, color: '#fff', fontSize: 18 }}>
                    {verifyType === 'phone' ? 'Phone Verification' : 'Email Verification'}
                  </h3>
                  <button
                    type="button"
                    onClick={closeOtpPopup}
                    style={{ background: 'none', border: 'none', color: '#aaa', fontSize: 22, cursor: 'pointer' }}
                  >
                    ✕
                  </button>
                </div>

                {/* Contact display (disabled) */}
                <div className="input-group" style={{ marginBottom: 16 }}>
                  <label style={{ color: '#ccc', fontSize: 12, marginBottom: 4, display: 'block' }}>
                    {verifyType === 'phone' ? 'Phone Number' : 'Email Address'}
                  </label>
                  <input
                    type="text"
                    disabled
                    value={verifyType === 'phone' ? userData.phone : userData.email}
                    style={{
                      width: '100%',
                      padding: '10px 12px',
                      borderRadius: 12,
                      border: '1px solid rgba(255,255,255,0.06)',
                      background: '#162c28',
                      color: '#fff',
                      fontSize: 14,
                    }}
                  />
                </div>

                {/* Error message */}
                {otpError && (
                  <div style={{ color: '#ff6b6b', fontSize: 12, marginBottom: 12 }}>
                    {otpError}
                  </div>
                )}

                {/* Send OTP button + timer */}
                <div className="input-group" style={{ marginBottom: 16 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <button
                      type="button"
                      disabled={otpSending || otpTimer > 0}
                      onClick={sendOtpCode}
                      style={{
                        padding: '10px 20px',
                        borderRadius: 6,
                        border: 'none',
                        background: otpTimer > 0 ? '#1a3a33' : 'linear-gradient(135deg, #4ade80, #22c55e)',
                        color: otpTimer > 0 ? 'rgba(255,255,255,0.4)' : '#091a21',
                        fontSize: 14,
                        fontWeight: 600,
                        cursor: otpTimer > 0 ? 'not-allowed' : 'pointer',
                        minWidth: 120,
                      }}
                    >
                      {otpSending ? 'Sending...' : otpTimer > 0 ? `Resend in ${formatTimer(otpTimer)}` : 'Send OTP'}
                    </button>
                    {otpSent && otpTimer > 0 && (
                      <span style={{ color: '#16a34a', fontSize: 12 }}>✓ Code sent!</span>
                    )}
                  </div>
                </div>

                {/* OTP code input (shown after code sent) */}
                {otpSent && (
                  <div className="input-group" style={{ marginBottom: 16 }}>
                    <label style={{ color: '#ccc', fontSize: 12, marginBottom: 4, display: 'block' }}>
                      Enter Verification Code
                    </label>
                    <input
                      type="tel"
                      maxLength={6}
                      placeholder="Enter 4-6 digit code"
                      value={otpCode}
                      onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ''))}
                      style={{
                        width: '100%',
                        padding: '10px 12px',
                        borderRadius: 12,
                        border: '1px solid rgba(255,255,255,0.06)',
                        background: '#162c28',
                        color: '#fff',
                        fontSize: 16,
                        letterSpacing: 4,
                        textAlign: 'center',
                      }}
                    />
                  </div>
                )}

                {/* Submit button (shown after code sent) */}
                {otpSent && (
                  <button
                    type="button"
                    disabled={otpVerifying || !otpCode}
                    onClick={submitOtpCode}
                    style={{
                      width: '100%',
                      padding: '12px',
                      borderRadius: 6,
                      border: 'none',
                      background: otpCode ? 'linear-gradient(135deg, #4ade80, #22c55e)' : '#1a3a33',
                      color: otpCode ? '#091a21' : 'rgba(255,255,255,0.4)',
                      fontSize: 16,
                      fontWeight: 600,
                      cursor: otpCode ? 'pointer' : 'not-allowed',
                    }}
                  >
                    {otpVerifying ? 'Verifying...' : 'Submit'}
                  </button>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default PersonalInformation;
